export const PING_PACKET_SIZE_OPTIONS = [
  {value: 64, label: 64},
  {value: 128, label: 128},
  {value: 256, label: 256},
  {value: 512, label: 512},
  {value: 1024, label: 1024},
];

export const COMMANDS = {
  PING: 'ping',
  TRACEROUTE: 'traceroute',
};

export const IP_OR_HOSTNAME_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;

export const STRINGS_TO_REMOVE = '\r\nType escape sequence to abort.\r\n';

export const SOURCE_PLACEHOLDER = 'Enter source';

export const TARGET_PLACEHOLDER = 'Enter hostname or IP address';
